/**
 * 破损登记
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2025, all rights reserved. Essa.cn
 */
import React,{PureComponent} from 'react';
import { Button, Spin, message, Drawer, } from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import {isEmptyObject,} from '@utils/utils';
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import Lang from "@/components/Lang/Lang";
import dayjs from 'dayjs';
import {isEmpty,getFileSuffix} from '@utils/utils';
import { ClaimLeft,ClaimRightPlan,ClaimRightHandle } from "@/components/DamageDetail";
import HttpServerAction from '@/api/httpServer.action';
import ClaimFormAdd from "../component/claimForm/add";
import warehouseService from '../warehouse.action';
import "./list.less";
export default class DamageRegistration extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            currentPage:1,//当前页
            loading: false,
            showDeleteModal:false,
            showDeleteId:"",
            // 抽屉状态
            drawerVisible: false,
            drawerData: null,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'poCode',
                    cnTitle:'订单编号',
                    cnTitleId:'DingDanBianHao',
                    width:220,
                },
                {
                    name:'keyword',
                    cnTitle:'客户编号',
                    cnTitleId:'KeHuBianHao',
                },
                {
                    name:'ShouHouDanHao',
                    cnTitle:'售后单号',
                    cnTitleId:'ShouHouDanHao',
                },
            ],
        }
    }
    // 查询回调
    fetchCallBack(res={}){
        const { paging={} } = res;
        this.setState({
            currentPage: paging.pageNum||1
        })
    }
    // 打开抽屉
    openDrawer = (flag=false) => {
        this.setState({
            drawerVisible: flag,
        });
    }
    // 详情抽屉
    openDetailDrawer = (flag=false,drawerData={}) => {
        this.setState({
            drawerDetailVisible: flag,
            drawerData: drawerData
        });
    }
    // 提交表单
   handleSubmit = async() => {
        const res = await this.onRefAddForm.handleOK();
        // &&values.refundAmountTotal
        if(res&&res.success){
            const postData = {
                ...res.data,
                // ...values,
            }
            this.save(postData,res.sku)
            // message.success(Lang({id: 'DengJiChengGong', default: '登记成功！'}));
        }else {
            message.error(res.message||Lang({id:"QingTianXieWanZhengDeBiTianXiang",default:"请填写完整的必填项"}));
        }
    }
    /**
     * 点击确认时 保护表单数据
     * 破损申请提交    http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#7960
     * 索赔审核提交   http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#6273
     ***/
    save(postData={},sku={}){
        const sUrl = "/service/mg/sale/claimDemage/damaged-apply";
        // 申请文件Id 索赔方式为 20:现金时 必填 索赔2.0新增
        // const { poItemId ,} = this.state;
        postData["poId"] = sku.poId;
        postData["poItemId"] = sku.poItemId;
        postData["buyerId"] = sku.buyerId; // 发起时此内容是跟查询po时返回的
        this.loading(true);
        warehouseService.postHttpAction(sUrl,postData,).then((resp)=>this.handleSaveRes(resp.data)).catch(err=>this.handleSaveRes(err));
    }
    loadingDetail(flag=false){
        this.setState({
            loadingDetail: flag
        })
    }
    loading(flag=false){
        this.setState({
            loading: flag
        })
    }

    handleSaveRes(resData={}){
        this.loading(false);
        const { success, valid,model={}} = resData;
        if (success &&valid) {
            // 新增时
            this.openDrawer();
            // 刷新页面
            if(this.onRefAutoFetchListChrld){
                this.onRefAutoFetchListChrld.handleFetch(1,{},true)
            }
        }else if(resData.message){
            message.warning(resData.message)
        }else {
            message.warning(this.__getServerLanguage("BaoCunShiBai"))
        }
    }
    /**
     * 列表
     * */
    renderList=(item,index)=>{
        return <div className="flex-item-ver-center oneItem font_14 black89" key={index+"-"+item.poId}>
            <div className={"leftBox"}>
                <div className="fw_700 lineH_30">{Lang({id: 'ShangPin', default: '商品'})}<span>{item.skuNo}</span></div>
                <div className={"color_FB7321"}>{Lang({id: 'PoSunShuLiang', default: '破损数量'})}：{item.wornQuantity} pcs</div>
            </div>
            <div className={"leftBox"}>
                <div className="fw_700 lineH_30">{Lang({id: 'DingDan', default: '订单'})}<span>{item.poCode}</span></div>
                <div className={"black45 lineH_23"}>{Lang({id: 'ShouHouDanHao', default: '售后单号'})}{item.cdOrderCode}</div>
                <div className={"black45 lineH_21"}>{item.cdOrderCreateTime?dayjs(item.cdOrderCreateTime).format("YYYY-MM-DD HH:mm:ss"):"-"}</div>
            </div>
            <div className={"flex-1"}>
                <div className="fw_700 lineH_30">{item.buyerCode}</div>
                <div className={"black45"}>{item.buyerName}</div>
            </div>
            <div className="ml_20 flex-item-ver-center">
            {/*状态 : claim_demage_order_status_mg
                        1        待处理  2        审核通过    3        已驳回  4        已撤销  5        已赔付
                        6        已失效  7        待汇款 8        已关闭 9        已发起*/}
                {
                    item.statusMgName?
                        <div className={`ui-status-label cursor-p ui-status-label${item.statusMg}`} onClick={()=>this.goPage(item)}>{item.statusMgName}</div>
                        :
                        null
                }
                <i className="ri-arrow-right-s-line font-16 ml_4"></i>
            </div>
        </div>
    }
    /**
     * 查看详情
     * */
    getDetail(claimDemageOrderId){
        const data ={
            claimDemageOrderId:claimDemageOrderId,
        }
        const sUrl =  "/service/mg/sale/claimDemage/claim-demage-info";
        this.loadingDetail(true)
        HttpServerAction.postHttpAction(sUrl,data,).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    handleRes(resData){
        this.loadingDetail(false);
        const { success,valid,model={}} = resData;
        if(success&valid){
            if(model.damageCode){
                const list = __getDictList("claim_demage_order_damage_code");
                const curDamage = list.find(item=>item.code==model.damageCode)||{};
                model.damageCodeName =curDamage.name;
            }
            this.setState({
                drawerData:model,
            },()=>{
                // if(this.onRefPageMgChild)this.onRefPageMgChild.init();//工作台是读取state数据，所以重新初始化
                // 如果索赔类型是现金，加载银行卡列表
            })
        }else {

        }
    }
    //跳转
    goPage(item) {
        this.getDetail(item.claimDemageOrderId);
        this.openDetailDrawer(true);
        // this.props.history.push("/warehouseManagement/damageDetail?"+item.claimDemageOrderId);
    }
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    onRefAdd = (ref) => this.onRefAddForm = ref;
    componentDidMount() {
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { loadingDetail=false, loading, searchFormOptions,sku={}, drawerVisible=false,drawerDetailVisible=false, drawerData={}} = this.state;
        const currPageName =  Lang({id: 'PoSunDengJi', default: '破损登记'});
        return (<Spin tip='loading' spinning={loading}>
                <CommonBreadcrumb list={[
                    {name:currPageName},
                ]}></CommonBreadcrumb>
                <div className={"damageRegistrationWrap"}>
                    <div className="flex-item-ver-center mb_12">
                        <span className="color-black fw_700 font_16 mr_12">{currPageName}</span>
                        <span className={"addBtn"} onClick={() => this.openDrawer(true)}>{Lang({id: 'XinZengDengJi', default: '新增登记'})}</span>
                    </div>
                    <AutoFetchList onRef={this.onRefAutoFetchList}
                                   searchFormOptions={searchFormOptions}
                                   precondition={{
                                       businessPlatform:"mg"
                                   }}
                                   fetchApi={'/service/mg/sale/claimDemage/claim-demage-list'}
                                   // searchReset={()=>this.searchReset()}
                                   renderList={this.renderList}
                    />
                </div>

                {/* Ant Design 5.0 Drawer Component */}
                <Drawer
                    title={<span />}
                    destroyOnClose={true}
                    placement="right"
                    width={700}
                    closable={false}
                    onClose={()=>this.openDrawer(false)}
                    open={drawerVisible}
                    extra={
                        <div>
                            <Button onClick={()=>this.openDrawer()} style={{ marginRight: 8 }}>
                                {Lang({id: 'QuXiaoDengJi', default: '取消登记'})}
                            </Button>
                            <Button className="btnPinkPrimary" onClick={this.handleSubmit}>
                                {Lang({id: 'TiJiaoDengJi', default: '提交登记'})}
                            </Button>
                        </div>
                    }
                >
                    <div className="damageRegistrationForm black89">
                        <ClaimFormAdd sku={sku}  onRef={this.onRefAdd}/>
                    </div>
                </Drawer>

                {/* 详情抽屉 */}
                <Drawer
                    title={<span />}
                    destroyOnClose={true}
                    placement="right"
                    width={700}
                    closable={false}
                    onClose={()=>this.openDetailDrawer(false)}
                    open={drawerDetailVisible}
                    extra={
                        <div>
                            <Button onClick={()=>this.openDetailDrawer(false)} style={{ marginRight: 8 }}>
                                {Lang({id: 'GuanBi', default: '关闭'})}
                            </Button>
                        </div>
                    }
                >
                    <Spin tip='loading' spinning={loadingDetail}>
                        <ClaimLeft model={drawerData} />
                        <div className={"mt_16"}>
                            {!isEmptyObject(drawerData)&&<ClaimRightPlan model={drawerData} values={drawerData} disable={true}/>}
                        </div>
                        <div className={"borderInfoCard mt_16"}>
                            <div className={"black89 fw_700 font_16"}>{Lang({id:"PeiShenChuLi",default:"赔偿处理"})}</div>
                            {!isEmptyObject(drawerData)&&<ClaimRightHandle model={drawerData} />}
                        </div>
                    </Spin>
                </Drawer>
            </Spin>
        )
    }
}

